module.exports = __webpack_public_path__ + "img/t3-media-block.834b17f8.png";